import React, { useState } from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import useStyles from '../../hooks/useStyles';
import styles from '../../assets/jss/linkExpired';
import resendVerification from '../../actions/resendVerification';

function LinkExpired(props) {
  const classes = useStyles(styles)();

  const { location } = props;

  const tokenPath = location.search;
  const [isResend, changeResend] = useState(false);

  let token = '';
  if (tokenPath) {
    token = tokenPath.replace('?token=', '');
  }

  function sendEmailLink() {
    resendVerification(token).then(() => {
      changeResend(true);
    });
  }

  return (
    <div className={classes.linkExpired}>
      {
        !isResend ? (
          <div>
            Link has been expired
            <div className={classes.linkResend}>
              <span
                aria-hidden="true"
                onClick={sendEmailLink}
                style={{
                  color: 'blue',
                  cursor: 'pointer',
                }}
              >
                Click here
              </span>
              {' '}
              to Request for new link
            </div>
          </div>
        )
          : (
            <div className={classes.newLink}>
              <CheckCircleIcon className={classes.successIcon} />
              {' '}
              New Link has been sent to your email
            </div>
          )
}

    </div>
  );
}

LinkExpired.propTypes = {};

export default LinkExpired;
